import history from '../history';

export const syncStateToQueryParams = (filters) => {
  const searchParams = new URLSearchParams(window.location.search)
  Object.keys(filters).forEach((key => {
    const currentQueryParam = searchParams.get(key);
    // Add/update if current filter has a value
    if (filters[key] != null) {
      searchParams.set(key, filters[key]);
    }
    // Remove if it does not have a value and currently has a value
    else if (currentQueryParam != null) {
      searchParams.delete(key);
    }
  }));

  const newRelativePathQuery = `${window.location.pathname}?${searchParams.toString()}${window.location.hash}`;
  history.push(newRelativePathQuery);
}